import React from 'react';
import css from './HeroFeatureGrid.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';

const homeFeature = [
    {
        icon: <IconCard brand="dailylog" />,
        heading: "Daily Logs",
        subHeading: "Stay informed and in control of every project."
    },
    {
        icon: <IconCard brand="prosnetwork" />,
        heading: "Subs Network",
        subHeading: "Achieve shared goals by pooling resources, skills, and efforts."
    },
    {
        icon: <IconCard brand="projectbidding" />,
        heading: "Project Bidding",
        subHeading: "You choose a bid that best aligns with your project's standards."
    },
    {
        icon: <IconCard brand="projectmanagement" />,
        heading: "Project Management",
        subHeading: "Simplify your workflow by managing your project in once place."
    },
]

function HeroFeatureGrid() {
    return (
        <div className={css.heroFeatures}>
            <div className={css.featureContainer}>
                {homeFeature.map((item, i) => {
                    return (
                        <div className={css.featureBox}>
                            <div className={css.featureIcon}>{item.icon}</div>
                            <div>
                                <div className={css.heading}>{item.heading}</div>
                                <div className={css.subHeading}>{item.subHeading}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default HeroFeatureGrid